import { procedureMap } from "./procedure";
import { timestampsMap } from "./timestamps";

export const surgicalExpertiseMap: GenericObject = {
	nome: "name",
	codigoprocedimento: "procedureCode",
	procedimento: {
		__key: "procedure",
		...procedureMap,
	},
	...timestampsMap,
};
